module.exports = __webpack_public_path__ + "img/carousel-3.8fee15ed.png";